import { useNewBookingsCount } from "@/hooks/useNewBookingsCount";
import { useNewAppFeedbackCount } from "@/hooks/useAppFeedback";

/**
 * Menu badge registry (C-CMS-DS, plans/ps-cms-shell.md T4) — SHARED FILE.
 *
 * Maps a menu id (see `NAV_GROUPS` in `navConfig.ts`) to a React HOOK returning the
 * number of things that need the Athlyn team there. `> 0` ⇒ a pink count pill
 * (a dot when the menu is collapsed); `0` / `undefined` / no entry ⇒ nothing.
 * The sidebar calls each hook unconditionally from one `NavBadge` per visible item.
 *
 * Children add ONLY their own line (master §2 shared-file rule; keep both on a
 * merge conflict): ps-cms-help adds `help`, ps-cms-engagement adds `app-feedback`.
 * Engagement score has no badge.
 */
export const NAV_BADGE_SOURCES: Partial<Record<string, () => number | undefined>> = {
  requests: useNewBookingsCount,
  "app-feedback": useNewAppFeedbackCount, // app feedback received in the last 7 days (ps-cms-engagement)
};
